import { Type } from "@sinclair/typebox";

import { DomainsRequestSchema } from "../domain/schema.js";
import { Domain } from "../shared/schema.js";
import { ServiceUserSchema, UserSchema } from "../user/schema.js";

export const InstituteResponseSchema = Type.Object({
  id: Type.String(),
  name: Type.String(),
  primaryDomain: Type.String(),
  users: Type.Array(UserSchema),
  serviceUsers: Type.Array(ServiceUserSchema),
  domains: Type.Array(Domain),
});

export const InstitutesResponseSchema = Type.Array(InstituteResponseSchema);

export const InstituteRequestSchema = Type.Object({
  name: Type.String(),
  users: Type.Array(UserSchema),
  serviceUsers: Type.Array(ServiceUserSchema),
  domains: DomainsRequestSchema,
});

export const CreateInstituteResponseSchema = Type.Object({
  status: Type.String(),
});

export const InstituteIdRequestParamsSchema = Type.Object({
  instituteId: Type.String(),
});
